import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ArrowRightIcon } from '../../../assets/ArrowRight';
import { PromoIcon } from '../../../assets/Promo';
import { AuthDrawer } from '../../../components/AuthDrawer';
import { Button } from '../../../components/ui/button';
import { Card } from '../../../components/ui/card';
import { userInfo } from '../../../store/selectors/user';
import { BackButtonHide } from '../../../utils/BackButton';
import { impactOccuer } from '../../../utils/hapticEvents';
import { useGetDealsList } from '../services/getDealsList';
import { DealsList } from './DealsList';

// Раздел «Промокоды» на странице «Акции» скрыт по задаче — только вход на
// него. Сам экран (/promotions/promocode) и применение промокода в корзине и
// на чекауте остаются; вернуть раздел — поставить true.
const SHOW_PROMOCODES_SECTION = false;

export const Promotion = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  BackButtonHide();
  const user = useSelector(userInfo);
  const [authOpen, setAuthOpen] = useState(false);
  const { deals, promoCodes, isLoading } = useGetDealsList();

  const isEmpty = !isLoading && !deals.length;

  return (
    <div className="flex h-full flex-col overflow-y-auto pb-safe-bottom pt-4">
      <p className="text-center text-display-sm text-text-primary">
        {t('promotion')}
      </p>

      <div className="flex flex-col space-y-4 px-4 pt-4">
        {!user.isAuth ? (
          <div className="flex flex-col space-y-4 rounded-2xl bg-fill-base p-4">
            <p className="px-0.5 text-center text-display-md text-text-primary">
              {t('promotions-auth-title')}
            </p>
            <Button
              className="h-12 w-full rounded-full bg-button-primary text-body-base-semibold text-text-white shadow-none"
              onClick={() => {
                impactOccuer('light');
                setAuthOpen(true);
              }}
            >
              {t('auth.card.button')}
            </Button>
            <AuthDrawer open={authOpen} setOpen={setAuthOpen} />
          </div>
        ) : null}

        {SHOW_PROMOCODES_SECTION ? (
          <div
            className="flex flex-row items-center space-x-3 rounded-xl bg-fill-base p-4"
            onClick={() => {
              impactOccuer('light');
              navigate('/promotions/promocode');
            }}
          >
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[10px] bg-fill-info">
              <PromoIcon className="text-text-white" />
            </div>
            <p className="min-w-0 flex-1 truncate text-body-base-regular text-text-primary">
              {t('my-promocodes')}
            </p>
            <div className="flex shrink-0 flex-row items-center space-x-1">
              {promoCodes.length ? (
                <div className="flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-fill-danger px-1 text-caption-xs-semibold text-text-white">
                  {promoCodes.length}
                </div>
              ) : null}
              <div className="flex h-5 w-5 items-center justify-center">
                <ArrowRightIcon className="h-[11px] w-[7px] text-text-icon-secondary" />
              </div>
            </div>
          </div>
        ) : null}

        {isLoading ? (
          <div className="flex flex-col space-y-2">
            {Array.from({ length: 2 }).map((_, index) => (
              <Card
                key={index}
                className="h-[344px] animate-pulse rounded-[20px] border-none bg-fill-base shadow-none"
              />
            ))}
          </div>
        ) : null}

        {deals.length ? (
          <div className="flex flex-col space-y-2 pt-4 first:pt-0">
            <p className="text-display-md text-text-primary">
              {t('all-promotions')}
            </p>
            <DealsList deals={deals} />
          </div>
        ) : null}

        {isEmpty ? (
          <div className="flex min-h-[300px] items-center justify-center">
            <p className="text-caption-sm-medium text-text-tertiary">
              {t('noPromo')}
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Promotion;
